import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  exchangeSchoolYearPath,
  nextYearClassesPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createClass,
  CREATE_CLASS_SUCCESS_MESSAGE,
  fetchTeachers,
  IClassParam,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import ClassForm from "../../../templates/manager/ClassForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { nextYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === CREATE_CLASS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(nextYearClassesPath);
    }
  }, [history, dispatch, state.success_message]);

  const createClassFunc = React.useCallback(
    (cls: IClassParam) => {
      dispatch(peep(createClass(cls)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchTeachers());
    return () => dispatch(clearErrorMessage());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
          {
            title: `${titles.nextYearClasses} (${nextYear}年度)`,
            to: nextYearClassesPath,
          },
        ]}
        currentTitle={`${titles.newNextYearClass} (${nextYear}年度)`}
      />
      <ClassForm
        title={`${titles.newNextYearClass} (${nextYear}年度)`}
        calling={calling}
        teacher_ids={[]}
        teachers={state.teachers}
        error={state.error}
        isNextYear={true}
        upsertClass={createClassFunc}
      />
    </div>
  );
};
